export default __webpack_public_path__ + "static/media/027b3c6f60db7060cfca71f5a1828ccf.svg";